<!-- @format -->

@if (inventoryExceededText()) {
	<div class="hmf-mb-m">
		<hmf-alert-banner
			type="warn"
			[title]="inventoryExceededText()"
		></hmf-alert-banner>
	</div>
} @else if (maxOrMinQuantityAlert()) {
	<div class="hmf-mb-m">
		<hmf-alert-banner
			type="warn"
			[title]="maxOrMinQuantityAlert()"
		></hmf-alert-banner>
	</div>
}
